var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonIdToken = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M20.47 5.21L6.492 15.762c-2.115 1.596-2.995 4.407-2.185 6.975l5.337 16.94C10.456 42.253 12.786 44 15.417 44h17.28c2.63 0 4.96-1.746 5.773-4.323l5.337-16.94c.81-2.567-.073-5.38-2.185-6.976L27.644 5.209a5.925 5.925 0 00-7.174 0z", fill: fills.light }),
        React.createElement("path", { d: "M19.078 21.048a5.007 5.007 0 015.008-5.008 5.007 5.007 0 015.008 5.008 5.007 5.007 0 01-5.008 5.008 5.007 5.007 0 01-5.008-5.008z", fill: fills.dark }),
        React.createElement("path", { d: "M15.513 29.532a5.002 5.002 0 013.54-1.465h10.041a5.002 5.002 0 015.003 5.003v1.005a1.997 1.997 0 01-1.997 1.997H16.06a2.013 2.013 0 01-2.014-2.013v-.988a5.018 5.018 0 011.467-3.54z", fill: fills.base })));
}, {
    name: identiconComponentName,
})({});
